import api from "../security/api";

const save = (client, instance, arrayRequest) => {
    return api
        .post(`audit/save?client=${client}&instance=${instance}`, arrayRequest);
};

const getAudit = (client, instance, doc, id) => {
    return api
        .get(`audit/findAll?client=${client}&instance=${instance}&doc=${doc}&id=${id}`);
};

const audit = {
    save,
    getAudit
}

export default audit;
